<template>
  <div class="griot-studio-container" :class="{ 'dark-mode': isDarkMode }">
    <!-- TOP BAR -->
    <div class="top-bar glass-panel">
      <!-- Left: Back & Identity -->
      <div class="top-bar-left">
        <button class="btn-subtle" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
           retour
        </button>
        <div class="bot-identity-group">
          <div class="logo-box">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"></path><path d="M8.5 8.5v.01"></path><path d="M16 16v.01"></path><path d="M12 12v.01"></path></svg>
          </div>
          <div class="bot-info">
             <h1 class="bot-name">{{ chatbotName || 'Griot Ai Studio' }}</h1>
             <div class="status-row">
                <div class="status-dot" :class="{ 'unsaved': hasUnsavedChanges }"></div>
                <span class="status-text">{{ chatbot?.bot_name || 'Chargement...' }} Infrastructure</span>
             </div>
          </div>
        </div>
      </div>

      <!-- Right: Actions -->
      <div class="top-bar-right">
        <button class="btn-icon-square" @click="toggleTheme">
            <svg v-if="isDarkMode" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
        </button>

        <div class="divider"></div>

        <!-- Sync button removed -->
      </div>
    </div>

    <!-- MAIN LAYOUT -->
    <div class="studio-body">
      
      <!-- 1. NAVIGATION RAIL (Desktop) -->
      <div class="nav-rail desktop-only-flex">
         <div class="nav-group">
            <button class="nav-item" :class="{ active: activeTab === 'blocks' }" @click="activeTab = 'blocks'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
               <div class="tooltip">Gérer les Blocs</div>
            </button>
            <button class="nav-item" :class="{ active: activeTab === 'products' }" @click="activeTab = 'products'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
               <div class="tooltip">Voir les Produits</div>
            </button>
            <button class="nav-item" :class="{ active: activeTab === 'files' }" @click="activeTab = 'files'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
               <div class="tooltip">Importer des Fichiers</div>
            </button>
            
            <div class="nav-divider"></div>

            <button class="nav-item" :class="{ active: activeTab === 'constitution' }" @click="activeTab = 'constitution'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
               <div class="tooltip">Constitution de l'agent</div>
            </button>
            <button v-if="isSuperAdmin" class="nav-item" :class="{ active: activeTab === 'prompt' }" @click="activeTab = 'prompt'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
               <div class="tooltip">Éditer le Prompt</div>
            </button>
            <button class="nav-item" :class="{ active: activeTab === 'chat' }" @click="activeTab = 'chat'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
               <div class="tooltip">Tester l'Agent</div>
            </button>
         </div>
         
         <div class="nav-group bottom">
            <button class="nav-item" :class="{ active: activeTab === 'settings' }" @click="activeTab = 'settings'">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
               <div class="tooltip">Réglages du Bot</div>
            </button>
         </div>
      </div>

         <div class="resource-explorer custom-scroll" :class="{ 'mobile-hidden': ['chat', 'prompt', 'constitution', 'settings'].includes(activeTab) }" v-if="!['prompt', 'constitution'].includes(activeTab)">
            <div class="explorer-header">
            <div class="header-titles">
               <h2>{{ getTabTitle(activeTab) }}</h2>
               <p>Édition des ressources</p>
            </div>
            <button v-if="activeTab==='files'" class="btn-fab" @click="triggerFileInput">
               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
         </div>

         <div class="search-row">
            <div class="search-input-wrapper">
               <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
               <input 
                  v-if="activeTab !== 'files'"
                  type="text" 
                  :placeholder="'Rechercher un ' + getTabLabel(activeTab) + '...'" 
                  v-model="searchQuery"
                  @input="handleSearch"
               >
               <input 
                  v-else
                  type="text" 
                  placeholder="Rechercher un fichier..." 
                  v-model="filesSearchQuery"
               >
            </div>
         </div>

         <div class="explorer-content">
             <div v-if="activeTab==='blocks'" class="selection-bar">
                <div class="flex gap-2">
                    <button class="btn-select-all" @click="toggleSelectAllBlocks" :title="areAllBlocksSelected ? 'Tout désélectionner' : 'Tout sélectionner'">
                        <svg v-if="areAllBlocksSelected" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square"><rect width="18" height="18" x="3" y="3" rx="2"></rect></svg>
                        <span class="btn-label">{{ areAllBlocksSelected ? 'Tout désélectionner' : 'Tout sélectionner' }}</span>
                    </button>
                    <span class="selection-count-badge" v-if="selectedBlocks.length > 0">{{ selectedBlocks.length }}</span>
                </div>
             </div>
              <div v-if="activeTab==='blocks'" class="cards-stack">
               <div v-for="block in filteredBlocks" :key="block.idblock" 
                    class="bento-card" 
                    :class="{ selected: isBlockSelected(block.idblock) }"
                    @click="toggleBlockSelection(block.idblock)">
                  
                  <div class="card-top">
                     <span class="type-pill">{{ block.type || 'Standard' }}</span>
                     <div class="selection-circle">
                        <svg v-if="isBlockSelected(block.idblock)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                     </div>
                  </div>
                  
                  <h4 class="card-title">{{ block.blockname }}</h4>
                  <p class="card-desc">{{ block.description || 'Aucune description' }}</p>
               </div>
             </div>

             <!-- PRODUCTS LIST -->
             <div v-if="activeTab==='products'" class="selection-bar">
                <div class="flex gap-2">
                    <button class="btn-select-all" @click="toggleSelectAllProducts" :title="areAllProductsSelected ? 'Tout désélectionner' : 'Tout sélectionner'">
                        <svg v-if="areAllProductsSelected" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square"><rect width="18" height="18" x="3" y="3" rx="2"></rect></svg>
                        <span class="btn-label">{{ areAllProductsSelected ? 'Tout désélectionner' : 'Tout sélectionner' }}</span>
                    </button>
                    <span class="selection-count-badge" v-if="selectedProducts.length > 0">{{ selectedProducts.length }}</span>
                </div>
             </div>
              <div v-if="activeTab==='products'" class="cards-stack">
                <div v-for="product in filteredProducts" :key="product._id" 
                    class="bento-card row-layout" 
                    :class="{ selected: isProductSelected(product._id) }"
                    @click="toggleProductSelection(product._id)">
                  
                  <div class="card-icon-box">
                     <img v-if="getProductImage(product)" :src="getProductImage(product)" class="product-img-cover" alt="Product" />
                     <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                  </div>
                  <div class="card-info">
                     <h4 class="card-title truncate">{{ product.title }}</h4>
                     <p class="card-meta">{{ formatPrice(product.price) }}</p>
                  </div>
                   <div class="selection-circle">
                        <svg v-if="isProductSelected(product._id)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                   </div>
                </div>
             </div>

             <!-- FILES LIST -->
             <div v-if="activeTab==='files'" class="cards-stack p-6 overflow-y-auto custom-scroll space-y-4">
                 <input type="file" ref="fileInput" class="hidden" @change="handleFileSelect" multiple accept=".pdf,.txt,.json,.doc,.docx,.xls,.xlsx,.csv,.md">
                 
                 <!-- Upload Box -->
                 <div class="p-10 rounded-[2.5rem] border-4 border-dashed flex flex-col items-center text-center gap-6 transition-all cursor-pointer group border-white/5 hover:border-emerald-500/30 hover:bg-emerald-500/5 bg-white/5"
                      @click="triggerFileInput" @drop.prevent="handleDrop" @dragover.prevent>
                     <div class="w-20 h-20 rounded-[2rem] flex items-center justify-center transition-transform group-hover:scale-110 duration-500 bg-white/5">
                         <svg v-if="!isUploading" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cloud-upload opacity-30" aria-hidden="true"><path d="M12 13v8"></path><path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"></path><path d="m8 17 4-4 4 4"></path></svg>
                         <svg v-else class="animate-spin opacity-50" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 1 1-6.219-8.56"></path></svg>
                     </div>
                     <div>
                         <p class="text-xs font-black uppercase tracking-[0.2em] mb-2">{{ isUploading ? 'UPLOAD EN COURS...' : 'IMPORTER UNE SOURCE' }}</p>
                         <p class="text-[10px] opacity-40 italic max-w-[180px] mx-auto">PDF métier, CGV, ou catalogue JSON (Max 10MB)</p>
                     </div>
                 </div>

                 <div class="pt-4 space-y-4">
                     <div class="flex items-center justify-between px-2" v-if="filteredFiles.length > 0">
                         <p class="text-[10px] font-black uppercase tracking-[0.3em] opacity-30">Vecteurs Actifs ({{ filteredFiles.length }})</p>
                     </div>
                     
                     <div v-for="file in filteredFiles" :key="file.filename || file.name" class="group p-5 rounded-3xl border-2 transition-all relative overflow-hidden bg-white/5 border-transparent hover:border-emerald-500/30">
                         <div class="flex items-center gap-5">
                             <div class="w-12 h-12 rounded-2xl flex items-center justify-center transition-all bg-opacity-10" 
                                  :class="getFileTypeColorClass(file)">
                                 <!-- Dynamic Icon based on file type -->
                                 <svg v-if="getFileType(file) === 'pdf'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                                 <svg v-else-if="getFileType(file) === 'json'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><circle cx="10" cy="13" r="2"></circle><line x1="20" y1="13" x2="16" y2="13"></line></svg>
                                 <svg v-else xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                             </div>
                             <div class="flex-1 min-w-0">
                                 <h4 class="text-xs font-black truncate uppercase tracking-tight">{{ file.name }}</h4>
                                 <div class="flex items-center gap-2 text-[9px] opacity-40 uppercase font-black mt-1">
                                     <span>{{ (file.size / 1024).toFixed(1) }} KB</span>
                                     <span>•</span>
                                     <span>{{ formatDate(file.uploadDate) }}</span>
                                 </div>
                             </div>
                             <button class="opacity-0 group-hover:opacity-100 p-2.5 text-red-500 hover:bg-red-500/10 rounded-xl transition-all" @click.stop="openDeleteModal(file.filename)">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                             </button>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
      </div>

      <!-- 3. MAIN CANVAS -->
      <div class="main-canvas custom-scroll" :class="{ 'mobile-hidden': ['blocks', 'products', 'files'].includes(activeTab) }">
         <!-- CASE 0: CONSTITUTION EDITOR -->
         <div v-if="activeTab === 'constitution'" class="canvas-content">
            <div class="canvas-header">
               <div>
                  <h3>Constitution de l'agent</h3>
                  <p>Le comportement, le ton et les limites de votre agent — en langage simple, sans technique.</p>
               </div>
               <div class="actions-group">
                  <button class="btn-action btn-save-constitution" :disabled="isSavingConstitution" @click="saveConstitution">
                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
                     {{ isSavingConstitution ? 'Enregistrement...' : 'Enregistrer' }}
                  </button>
               </div>
            </div>

            <div class="constitution-grid">
               <div class="const-field">
                  <label><span class="const-emoji">🎯</span> Objectif — il sert à quoi ?</label>
                  <p class="const-hint">L'objectif principal d'une conversation réussie (ex : répondre aux questions et orienter vers le bon contenu).</p>
                  <textarea v-model="constitution.objectif" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Ex : Accompagner les parents dans l'inscription de leur enfant et répondre à leurs questions."></textarea>
               </div>

               <div class="const-field">
                  <label><span class="const-emoji">👥</span> Public — il parle à qui ?</label>
                  <p class="const-hint">Public cible, langue principale, contexte culturel ou géographique.</p>
                  <textarea v-model="constitution.audience" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Ex : Parents et élèves au Sénégal, en français, registre accessible."></textarea>
               </div>

               <div class="const-field">
                  <label><span class="const-emoji">🗣️</span> Ton — comment doit-il répondre ?</label>
                  <p class="const-hint">Chaleureux / pro / fun, tutoiement ou vouvoiement, messages courts ou détaillés, émojis ou pas.</p>
                  <textarea v-model="constitution.ton" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Ex : Chaleureux et rassurant, tutoiement, messages courts, quelques émojis."></textarea>
               </div>

               <div class="const-field">
                  <label><span class="const-emoji">🚫</span> Interdits — de quoi ne doit-il jamais parler ?</label>
                  <p class="const-hint">Sujets hors périmètre, et ce qu'il ne doit jamais inventer (prix, délais, promos…).</p>
                  <textarea v-model="constitution.interdits" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Ex : Ne jamais inventer de tarif. Pour les sujets sensibles, comprendre et orienter vers une personne ou ressource adaptée."></textarea>
               </div>

               <div class="const-field const-field-full">
                  <label><span class="const-emoji">💡</span> Valeurs & comportements</label>
                  <p class="const-hint">Les principes qui guident l'agent (ex : « comprend et oriente, ne moralise pas »).</p>
                  <textarea v-model="constitution.valeurs" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Une valeur / un comportement par ligne."></textarea>
               </div>

               <div class="const-field const-field-full">
                  <label><span class="const-emoji">📝</span> Notes libres (optionnel)</label>
                  <p class="const-hint">Tout ce qui n'entre pas dans les champs ci-dessus.</p>
                  <textarea v-model="constitution.notes" @input="hasUnsavedConstitution = true" class="const-textarea custom-scroll" rows="3" placeholder="Notes additionnelles…"></textarea>
               </div>
            </div>

            <div class="const-footer-hint">
               Cette constitution est injectée en priorité dans le cerveau de l'agent à chaque réponse. Moo peut aussi la remplir en vous posant quelques questions.
            </div>
         </div>

         <!-- CASE 1: PROMPT EDITOR -->
         <div v-else-if="activeTab === 'prompt'" class="canvas-content">
             <div class="canvas-header">
                <div>
                   <h3>Neural Architecture</h3>
                   <p>Configuration de la couche logique d'Indi Tekk.</p>
                </div>
                <div class="actions-group">
                   <button class="btn-action" @click="copyPromptToClipboard">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                      Copier
                   </button>
                   <button class="btn-action" @click="generateContextualPrompt">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                      Générer
                   </button>
                </div>
             </div>

             <div class="code-window">
                <div class="window-bar">
                   <div class="traffic-lights">
                      <div class="light red"></div>
                      <div class="light yellow"></div>
                      <div class="light green"></div>
                   </div>
                   <div class="window-title">system_engine.md</div>
                </div>
                <!-- Editor Area -->
                 <textarea 
                    v-model="editablePrompt" 
                    class="code-editor custom-scroll"
                    placeholder="Le prompt généré apparaîtra ici..."
                    spellcheck="false"
                 ></textarea>
             </div>
             
             <!-- DEBUG SECTION -->
              <div v-if="showDebug && debugSystemPrompt" class="mt-8 p-4 rounded-xl bg-black/20 border border-white/5 font-mono text-xs text-white/70">
                  <div class="flex justify-between items-center mb-2">
                       <h4 class="uppercase tracking-widest opacity-50 font-bold">Server Response Debug</h4>
                       <button @click="showDebug = false" class="text-white/30 hover:text-white">Fermer</button>
                  </div>
                  <pre class="overflow-x-auto p-4 bg-black/40 rounded-lg">{{ JSON.stringify(debugSystemPrompt, null, 2) }}</pre>
              </div>
         </div>

         <!-- CASE 2: CHAT -->
         <div v-else-if="activeTab === 'chat'" class="canvas-content chat-mode">
            <div class="empty-chat" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
               <h3>Mode Test</h3>
               <p>Utilisez le widget en bas à droite pour tester votre agent.</p>
            </div>
         </div>

         <!-- CASE 3: DASHBOARD / DEFAULT -->
         <div v-else class="canvas-content dashboard-mode" :class="{ 'with-bg-glow': true }">
            <div class="dashboard-intro">
               <h3>System Builder</h3>
               <p>Base de connaissance</p>
            </div>

            <div class="grid-2-col">
               <!-- Blocks Status -->
               <div class="status-card">
                  <div class="card-header">
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-accent" style="color: #10B981;"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                     <h4>Blocs sélectionnés ({{ selectedBlocks.length }})</h4>
                  </div>
                  <div class="mini-list">
                     <div v-if="selectedBlocks.length === 0" class="empty-text">Aucun bloc configuré</div>
                     <div v-for="id in selectedBlocks" :key="id" class="mini-item mini-item-lg">
                        <div class="mini-icon-box">
                           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                        </div>
                        <div class="mini-item-info">
                           <span class="mini-item-name">{{ getBlockName(id) }}</span>
                           <span class="mini-item-id">{{ id }}</span>
                        </div>
                     </div>
                  </div>
               </div>

               <!-- Products Status -->
               <div class="status-card">
                  <div class="card-header">
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-accent" style="color: #3B82F6;"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                     <h4>Produits actifs ({{ selectedProducts.length }})</h4>
                  </div>
                  <div class="mini-list">
                     <div v-if="selectedProducts.length === 0" class="empty-text">Aucun produit mappé</div>
                     <div v-for="id in selectedProducts" :key="id" class="mini-item mini-item-lg">
                        <div class="mini-icon-box">
                           <img v-if="getProductImage(getProductById(id))" :src="getProductImage(getProductById(id))" class="mini-product-img" alt="img" />
                           <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        </div>
                        <div class="mini-item-info">
                           <span class="mini-item-name">{{ getProductName(id) }}</span>
                           <span class="mini-item-id">{{ id }}</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Sync Status (Restored) -->
            <div class="sync-card-wrapper">
               <div class="sync-status-row">
                  <div class="sync-icon-box" :class="{ 'active': hasUnsavedChanges }">
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>
                  </div>
                  <div class="sync-info">
                     <h4>Statut de la base de connaissance</h4>
                     <p v-if="hasUnsavedChanges">Changements détectés : mise à jour requise</p>
                     <p v-else>Base de connaissance synchronisée</p>
                  </div>
                  <button class="btn-sync-action" :class="{ 'pulse': hasUnsavedChanges }" @click="generateContextualPrompt">
                      <span v-if="claudeIntegration.isProcessing">Mise à jour en cours...</span>
                      <span v-else>Mettre à jour la base de connaissance</span>
                  </button>
               </div>
            </div>
         </div>
      </div>
      
      <!-- MOBILE BOTTOM NAV -->
      <div class="mobile-bottom-nav mobile-only-flex">
          <button class="mobile-nav-item" :class="{ active: activeTab === 'blocks' }" @click="activeTab = 'blocks'">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
              <span>Blocs</span>
          </button>
          <button class="mobile-nav-item" :class="{ active: activeTab === 'chat' }" @click="activeTab = 'chat'">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
              <span>Chat</span>
          </button>
           <button class="mobile-nav-item" :class="{ active: activeTab === 'constitution' }" @click="activeTab = 'constitution'">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
              <span>Const.</span>
          </button>
           <button v-if="isSuperAdmin" class="mobile-nav-item" :class="{ active: activeTab === 'prompt' }" @click="activeTab = 'prompt'">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
              <span>Prompt</span>
          </button>
           <button class="mobile-nav-item" :class="{ active: activeTab === 'products' }" @click="activeTab = 'products'">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
              <span>Cat.</span>
          </button>
           <button class="mobile-nav-item" :class="{ active: activeTab === 'settings' }" @click="activeTab = 'settings'">
               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
              <span>Config</span>
          </button>
      </div>

    </div>

    <!-- Toast Notification -->
    <div v-if="showToast" class="toast-notification" :class="toastType">
        <svg v-if="toastType === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        <span>{{ toastMessage }}</span>
    </div>
    <!-- Custom Delete Modal -->
    <transition name="fade">
        <div v-if="showDeleteModal" class="modal-overlay" @click.self="closeDeleteModal">
            <div class="modal-card">
                <div class="modal-icon-wrapper">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-red-500">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                </div>
                <h3>Supprimer ce fichier ?</h3>
                <p>Cette action est irréversible. Le fichier <span class="text-white font-bold">{{ fileToDelete }}</span> sera définitivement effacé.</p>
                <div class="modal-actions">
                    <button class="btn-cancel" @click="closeDeleteModal" :disabled="isDeleting">Annuler</button>
                    <button class="btn-confirm-delete" @click="confirmDelete" :disabled="isDeleting">
                        <span v-if="isDeleting">Suppression...</span>
                        <span v-else>Supprimer</span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { axiosPeelo } from '@/utils/axios';
import { ClaudePromptGenerator, createClaudeIntegration } from '@/utils/claudePromptGenerator.js'
import { apiBaseUrl } from '@/config'
import { consoleLog, consoleError } from '@/utils/logger';
import { isSuperAdmin } from '@/utils/permissions';

export default {
  name: 'GriotBuilderView',
  data() {
    return {
      // Configuration & State
      isDarkMode: true,
      activeTab: 'blocks', // blocks, products, files, prompt, chat, settings
      isSyncing: false,
      hasUnsavedChanges: false, // In a real app, track deep changes
      
      // Data
      chatbot: null,
      selectedBlocks: [],
      selectedProducts: [],
      uploadedFiles: [],
      
      // Filter & Search
      searchQuery: '',
      blocksSearchQuery: '',
      productsSearchQuery: '',
      filesSearchQuery: '',
      
      // Loaded Data
      availableBlocks: [],
      availableProducts: [],
      
      // Scraping Stats
      scrapingStats: {
        totalBlocks: 0,
        scrapedBlocks: 0
      },
      flowDataCache: null,
      
      // Claude / Prompt
      editablePrompt: '',
      testMessage: '',
      testResults: [],
      isTesting: false,

      // Constitution (couche métier non-technique)
      constitution: {
        objectif: '',
        audience: '',
        ton: '',
        interdits: '',
        valeurs: '',
        notes: ''
      },
      isSavingConstitution: false,
      hasUnsavedConstitution: false,
      
      // File Upload
      isUploading: false,
      
      // Utils
      claudeIntegration: {
        fullStructurePayload: '',
        promptStats: {}
      },
      
      // Toast
      toastMessage: '',
      toastType: 'success', // 'success' or 'error'
      showToast: false,
      toastTimeout: null,
      
      // Delete Modal
      showDeleteModal: false,
      fileToDelete: null,
      isDeleting: false,
      
      // Debug
      debugSystemPrompt: null,
      showDebug: false
    };
  },
  computed: {
    isSuperAdmin() { return isSuperAdmin() },
    chatbotId() { return this.$route.params.idchatbot },
    filteredBlocks() {
        if (!this.searchQuery && !this.blocksSearchQuery) return this.availableBlocks;
        const q = (this.searchQuery || this.blocksSearchQuery).toLowerCase();
        return this.availableBlocks.filter(b => (b.blockname || '').toLowerCase().includes(q));
    },
    filteredProducts() {
        if (!this.searchQuery && !this.productsSearchQuery) return this.availableProducts;
        const q = (this.searchQuery || this.productsSearchQuery).toLowerCase();
        return this.availableProducts.filter(p => (p.title || '').toLowerCase().includes(q));
    },
    chatbotName() {
        return this.chatbot ? this.chatbot.bot_name : '';
    },
    areAllBlocksSelected() {
        if (!this.filteredBlocks.length) return false;
        const visibleIds = this.filteredBlocks.map(b => b.idblock);
        return visibleIds.every(id => this.selectedBlocks.includes(id));
    },
    areAllProductsSelected() {
        if (!this.filteredProducts.length) return false;
        const visibleIds = this.filteredProducts.map(p => p._id);
        return visibleIds.every(id => this.selectedProducts.includes(id));
    },
    filteredFiles() {
        if (!this.filesSearchQuery) return this.uploadedFiles;
        const q = this.filesSearchQuery.toLowerCase();
        return this.uploadedFiles.filter(f => f.name.toLowerCase().includes(q));
    }
  },
  watch: {
    activeTab(newTab, oldTab) {
        if (newTab === 'files') {
            this.loadDocuments();
        }
        
        // Handle Widget Injection for Chat & Prompt Mode
        const widgetModes = ['chat', 'prompt'];
        const isTargetMode = widgetModes.includes(newTab);
        const wasTargetMode = widgetModes.includes(oldTab);

        if (isTargetMode) {
            // Only inject if not coming from another supported mode (to keep state)
            if (!wasTargetMode) {
                this.injectWidgetScript();
            }
        } else {
            this.removeWidgetScript();
        }
    }
  },
  mounted() {
    this.initializeKnowledge();
  },
  beforeUnmount() {
    this.removeWidgetScript();
  },
  methods: {
    injectWidgetScript(retries = 0) {
       // Retry if chatbot not loaded yet
       if (!this.chatbot || !this.chatbot._id) {
           if (retries > 20) {
               console.error("GriotBuilder: Chatbot data load timeout. Widget injection aborted.");
               return; // Stop after ~20 seconds
           }
           setTimeout(() => this.injectWidgetScript(retries + 1), 1000);
           return;
       }

       // Remove existing if any (cleanup)
       const existingScript = document.getElementById('peelo-jssdk');
       if (existingScript) existingScript.remove();
       const existingIframe = document.getElementById('peelo-widget-iframe');
       if (existingIframe) existingIframe.remove();

       // User Config
       let adminUser = {
           name: "Admin Peelo",
           email: "admin@peelo.io",
           phone: "221770000000"
       };
       
       const userData = localStorage.getItem('user');
       if (userData) {
           try {
               const parsed = JSON.parse(userData);
               if (parsed.data && parsed.data.user) {
                   const u = parsed.data.user;
                   adminUser.name = u.name || adminUser.name;
                   adminUser.email = u.email || adminUser.email;
                   adminUser.phone = u.phone || adminUser.phone;
               }
           } catch(e) {}
       }

       // Create Script
       const script = document.createElement('script');
       script.id = 'peelo-jssdk';
       const baseUrl = "https://agenttalk.peelo.io/embed.js";
       
       // Construct SRC with params
       const params = new URLSearchParams();
       params.append('id', this.chatbot._id);
       params.append('email', adminUser.email);
       params.append('name', adminUser.name);
       params.append('phone', adminUser.phone);
       params.append('open', 'true'); // Auto-open widget
       params.append('pgdebug', '1'); // contexte Playground → active la commande /debug du widget

       script.src = `${baseUrl}?${params.toString()}`;
       
       document.body.appendChild(script);
    },
    removeWidgetScript() {
       const existingScript = document.getElementById('peelo-jssdk');
       if (existingScript) existingScript.remove();
       const existingIframe = document.getElementById('peelo-widget-iframe');
       if (existingIframe) existingIframe.remove();
    },
    /* --- NAVIGATION --- */
    goBack() {
      this.$router.push(`/dashboard/chatbots/${this.chatbotId}/home`);
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
    },
    
    /* --- LOGIC ADAPTERS --- */
    getTabTitle(tab) {
        if(tab === 'blocks') return 'Blocs Métier';
        if(tab === 'products') return 'Catalogue';
        if(tab === 'files') return 'Fichiers Sources';
        return 'Ressources';
    },
    getTabLabel(tab) {
        if(tab === 'blocks') return 'bloc';
        if(tab === 'products') return 'produit';
        if(tab === 'files') return 'fichier';
        return 'élément';
    },
    
    /* --- DATA MANAGEMENT --- */
    async initializeKnowledge() {
        await Promise.all([
          this.loadChatbotInfo(),
          this.loadBlocks(), // Need implementation
          this.loadProducts() // Need implementation
        ]);
    },
    toggleSelectAllBlocks() {
        const visibleIds = this.filteredBlocks.map(b => b.idblock);
        if (this.areAllBlocksSelected) {
            this.selectedBlocks = this.selectedBlocks.filter(id => !visibleIds.includes(id));
        } else {
            const newIds = visibleIds.filter(id => !this.selectedBlocks.includes(id));
            this.selectedBlocks = [...this.selectedBlocks, ...newIds];
        }
    },
    toggleSelectAllProducts() {
        const visibleIds = this.filteredProducts.map(p => p._id);
        if (this.areAllProductsSelected) {
            this.selectedProducts = this.selectedProducts.filter(id => !visibleIds.includes(id));
        } else {
            const newIds = visibleIds.filter(id => !this.selectedProducts.includes(id));
            this.selectedProducts = [...this.selectedProducts, ...newIds];
        }
    },
    async loadChatbotInfo() {
      try {
        const response = await axiosPeelo.get(`/get/strong/chatbot/${this.chatbotId}`);
        if (response.data?.chatbot) {
          this.chatbot = response.data.chatbot;
          // Load system prompt
          const promptRes = await axiosPeelo.get(`/knowledge/jarvis/${this.chatbotId}/system-prompt`);
          if (promptRes.data?.systemPrompt) {
              const sp = promptRes.data.systemPrompt;
              
              // Debug
              this.debugSystemPrompt = promptRes.data;
              console.log("🐛 SYSTEM PROMPT DEBUG:", this.debugSystemPrompt);

              if (sp.blocks) this.selectedBlocks = sp.blocks.map(b => b.idblock);
              if (sp.products?.catalog) this.selectedProducts = sp.products.catalog.map(p => p._id);
              
              // Load the prompt text if available
              if (typeof sp === 'string') {
                  this.editablePrompt = sp;
              } else if (sp.promptblock) {
                  this.editablePrompt = sp.promptblock;
              } else if (sp.prompt) {
                  this.editablePrompt = sp.prompt;
              }
          }

          // Charger la constitution (indépendante de la présence du system prompt)
          const c = promptRes.data?.constitution;
          if (c && typeof c === 'object') {
              this.constitution = {
                  objectif: c.objectif || '',
                  audience: c.audience || '',
                  ton: c.ton || '',
                  interdits: c.interdits || '',
                  valeurs: c.valeurs || '',
                  notes: c.notes || ''
              };
              this.hasUnsavedConstitution = false;
          }
        }
      } catch (e) {
        console.error("Load Chatbot Info Error", e);
      }
    },
    async saveConstitution() {
      if (this.isSavingConstitution) return;
      this.isSavingConstitution = true;
      try {
        const res = await axiosPeelo.post(
          `/knowledge/jarvis/${this.chatbotId}/constitution`,
          { constitution: { ...this.constitution } }
        );
        if (res.data?.success) {
          this.hasUnsavedConstitution = false;
          this.showNotification('Constitution enregistrée', 'success');
        } else {
          this.showNotification(res.data?.message || 'Échec de l\'enregistrement', 'error');
        }
      } catch (e) {
        consoleError('saveConstitution error', e);
        this.showNotification('Erreur lors de l\'enregistrement de la constitution', 'error');
      } finally {
        this.isSavingConstitution = false;
      }
    },
    /* Mock Loaders for existing Vue logic compatibility */
    async loadBlocks() {
      // Re-using logic from loadScrapingStats in backup
      try {
        const response = await axiosPeelo.get(`/strong/get/chatbot/${this.chatbotId}/flowall`);
        
        if (response.data && response.data.success) {
          this.flowDataCache = response.data;
          this.extractAvailableBlocks(response.data.flow);
          this.scrapingStats.totalBlocks = this.availableBlocks.length;
        }
      } catch (e) {
        consoleLog("Blocks load error", e);
      }
    },

    async loadProducts() {
      this.isLoadingProducts = true;
      try {
        const response = await axios.get(
          `https://apicommerce.aipeelo.xyz/api/chatbots/${this.chatbotId}/products`
        );
        
        if (response.data && response.data.success) {
          this.availableProducts = response.data.products || [];
          console.log('📦 Produits chargés (GriotBuilder):', this.availableProducts);
          // Removed manual assignment to filteredProducts as it is a computed property
          
          // Re-apply selection if needed (restored from prompt)
          // If already selected via chatbotInfo, we are good.
        }
      } catch (error) {
        console.error('Erreur lors du chargement des produits:', error);
      } finally {
        this.isLoadingProducts = false;
      }
    },
    
    extractAvailableBlocks(flowData) {
      const blocks = [];
      
      // Add main blocks
      if (flowData.mainblocks) {
        Object.entries(flowData.mainblocks).forEach(([type, blockArray]) => {
          if (Array.isArray(blockArray)) {
            blockArray.forEach(block => {
              blocks.push({
                ...block,
                blockname: `${type.charAt(0).toUpperCase() + type.slice(1)} Block`,
                type: type,
                description: 'Bloc principal du chatbot', // Mapped for new design
                elementsCount: 0
              });
            });
          }
        });
      }
      
      // Add regular blocks
      if (flowData.blocks && Array.isArray(flowData.blocks)) {
        flowData.blocks.forEach(block => {
          const contentPreview = this.generateBlockPreview(block);
          const elementsCount = block.flow ? block.flow.length : 0
          
          blocks.push({
            ...block,
            description: contentPreview, // Mapped for new design
            elementsCount
          });
        });
      }
      
      this.availableBlocks = blocks;
      // Removed manual assignment to filteredBlocks as it is a computed property
      
      // Default select all if empty
      if (this.selectedBlocks.length === 0) {
          this.selectedBlocks = blocks.map(b => b.idblock);
      }
    },

    generateBlockPreview(block) {
      if (!block.flow || block.flow.length === 0) return 'Bloc vide';
      const textElements = block.flow.filter(e => e.type === 'text' || e.type === 'text_button');
      if (textElements.length === 0) return `${block.flow.length} élément(s)`;
      const firstText = textElements[0].message || '';
      return firstText.length > 80 ? firstText.substring(0, 80) + '...' : firstText;
    },

    isStandardBlock(block) {
       return !['ai_f', 'function', 'api'].includes(block.type);
    },

    
    /* --- ACTIONS --- */
    handleSync() {
        this.isSyncing = true;
        setTimeout(() => {
            this.isSyncing = false;
            this.hasUnsavedChanges = false;
        }, 1500);
    },
    toggleBlockSelection(id) {
        if(this.selectedBlocks.includes(id)) 
            this.selectedBlocks = this.selectedBlocks.filter(b => b !== id);
        else 
            this.selectedBlocks.push(id);
        this.hasUnsavedChanges = true;
    },
    isBlockSelected(id) { return this.selectedBlocks.includes(id) },
    
    toggleProductSelection(id) {
         if(this.selectedProducts.includes(id)) 
            this.selectedProducts = this.selectedProducts.filter(p => p !== id);
        else 
            this.selectedProducts.push(id);
        this.hasUnsavedChanges = true;
    },
    isProductSelected(id) { return this.selectedProducts.includes(id) },
    
    /* --- FILE MANAGEMENT --- */
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileSelect(event) {
      const files = Array.from(event.target.files);
      if (files.length > 0) {
        await this.uploadFiles(files);
      }
    },
    async handleDrop(event) {
       event.preventDefault();
       const files = Array.from(event.dataTransfer.files);
       if (files.length > 0) {
           await this.uploadFiles(files);
       }
    },
    
    async uploadFiles(files) {
      if (!files || files.length === 0) return;
      this.isUploading = true;

      const formData = new FormData();
      files.forEach(file => formData.append('files', file));

      try {
          const response = await fetch(`https://jarvis.aipeelo.xyz/upload/knowledge/jarvis/${this.chatbotId}/documents`, {
              method: 'POST',
              body: formData
          });

          const data = await response.json();

          if (data.success) {
              await this.loadDocuments();
              this.showNotification('Fichiers importés avec succès !');
          } else {
              console.error("Upload failed", data);
              this.showNotification('Échec de l\'import des fichiers', 'error');
          }
      } catch (e) {
          console.error("Upload error", e);
          this.showNotification('Erreur lors de l\'import', 'error');
      } finally {
          this.isUploading = false;
      }
    },

    async loadDocuments() {
      try {
          const response = await fetch(`https://jarvis.aipeelo.xyz/upload/knowledge/jarvis/${this.chatbotId}/documents`);
          const data = await response.json();

          if (data.success && data.data && data.data.documents) {
              this.uploadedFiles = data.data.documents;
          }
      } catch (e) {
          console.error("Load documents error", e);
      }
    },

    openDeleteModal(filename) {
        this.fileToDelete = filename;
        this.showDeleteModal = true;
    },
    
    closeDeleteModal() {
        this.showDeleteModal = false;
        setTimeout(() => {
            this.fileToDelete = null;
        }, 300);
    },

    async confirmDelete() {
        if (!this.fileToDelete) return;
        
        // Find index in the original list (matching server order)
        const index = this.uploadedFiles.findIndex(f => f.filename === this.fileToDelete);
        
        if (index === -1) {
            this.showNotification('Erreur: Fichier introuvable', 'error');
            return;
        }

        this.isDeleting = true;
        try {
            const response = await fetch(`https://jarvis.aipeelo.xyz/upload/knowledge/jarvis/${this.chatbotId}/documents/${index}`, {
                method: 'DELETE'
            });
            const data = await response.json();
            
            if (data.success) {
                this.showNotification('Fichier supprimé avec succès');
                await this.loadDocuments();
                this.closeDeleteModal();
            } else {
                 console.error("Delete failed", data);
                 this.showNotification('Erreur lors de la suppression: ' + (data.message || 'Inconnue'), 'error');
            }
        } catch (e) {
            console.error("Delete document error", e);
            this.showNotification('Erreur système', 'error');
        } finally {
            this.isDeleting = false;
        }
    },
    /* --- HELPERS --- */
    getFileTypeClass(file) {
        if(file.name.endsWith('.pdf')) return 'pdf';
        if(file.name.endsWith('.json')) return 'json';
        return 'txt';
    },
    formatDate(d) { return new Date(d).toLocaleDateString(); },
    formatDate(d) { return new Date(d).toLocaleDateString(); },
    formatPrice(p) { return p ? `${p}€` : 'Gratuit'; },
    
    getProductImage(product) {
       // 1. Direct images array
       if (product.images && Array.isArray(product.images) && product.images.length > 0) {
           return product.images[0];
       }
       // 2. Variants images
       if (product.variants && Array.isArray(product.variants)) {
           for (const variant of product.variants) {
               if (variant.images && Array.isArray(variant.images) && variant.images.length > 0) {
                   return variant.images[0];
               }
               // Check if variant has single image property
               if (variant.image) return variant.image;
           }
       }
       // 3. Fallback legacy
       return product.image || product.imageUrl || null;
    },
    
    getProductById(id) {
       return this.availableProducts.find(p => p._id === id) || {};
    },
    
    getBlockName(id) {
        const b = this.availableBlocks.find(x => x.idblock === id);
        return b ? b.blockname : id;
    },
    getProductName(id) {
         const p = this.availableProducts.find(x => x._id === id);
        return p ? p.title : id;
    },
    
    /* --- PROMPT & CHAT --- */
    async generateContextualPrompt() {
        this.claudeIntegration.isProcessing = true;
        try {
            // 1. Gather selected resources
            const selectedBlockObjects = this.availableBlocks.filter(b => this.selectedBlocks.includes(b.idblock));
            const selectedProductObjects = this.availableProducts.filter(p => this.selectedProducts.includes(p._id));
            
            // 2. Construct Flow Data Object for Generator
            // Note: We need to reconstruct the structure expected by ClaudePromptGenerator
            const flowData = {
                chatbotInfo: this.chatbot,
                flow: {
                    blocks: selectedBlockObjects,
                    // Main blocks are already flattened into availableBlocks with type 'mainblock_...'
                    // distinct mainblocks if needed, but generator handles flattening or structured.
                    // Let's rely on extractDetailedBlockInformations which expects blocks and mainblocks.
                    // For simplicity, we pass all selected as 'blocks' and let the generator process them.
                    mainblocks: {} 
                },
                products: {
                    catalog: selectedProductObjects,
                    totalProducts: selectedProductObjects.length
                }
            };

            // 3. Generate Prompt
            const prompt = ClaudePromptGenerator.generateOptimizedSystemPrompt(flowData);
            this.editablePrompt = prompt;
            
            this.showNotification('Prompt généré avec succès based sur la sélection');
            
        } catch (e) {
            console.error("Prompt Generation Error", e);
            this.showNotification('Erreur lors de la génération du prompt', 'error');
        } finally {
            this.claudeIntegration.isProcessing = false;
        }
    },
    testPrompt() {
        if(!this.testMessage) return;
        this.testResults.push({
            role: 'user',
            message: this.testMessage
        });
        this.isTesting = true;
        setTimeout(() => {
            this.testResults.push({
                role: 'bot',
                message: "Ceci est une réponse simulée par le nouveau Griot Builder."
            });
            this.isTesting = false;
        }, 1000);
        this.testMessage = '';
    },
    isTextResponse(res) { return res.response?.response?.message },
    copyPromptToClipboard() {},
    handleSearch() {},
    
    /* --- HELPERS FOR NEW FILE DESIGN --- */
    getFileType(file) {
        const name = file.name || file.filename || '';
        if (name.toLowerCase().endsWith('.pdf')) return 'pdf';
        if (name.toLowerCase().endsWith('.json')) return 'json';
        return 'other';
    },
    getFileTypeColorClass(file) {
        const type = this.getFileType(file);
        if (type === 'pdf') return 'bg-red-500/10 text-red-500';
        if (type === 'json') return 'bg-blue-500/10 text-blue-500';
        return 'bg-gray-500/10 text-gray-500';
    },
    
    /* --- TOAST --- */
    showNotification(message, type = 'success') {
        this.toastMessage = message;
        this.toastType = type;
        this.showToast = true;
        
        if (this.toastTimeout) clearTimeout(this.toastTimeout);
        this.toastTimeout = setTimeout(() => {
            this.showToast = false;
        }, 3000);
    }
  }
};
</script>

<style scoped>
/* --- THEME VARIABLES --- */
.griot-studio-container {
    --peelo-green: #143028;
    --peelo-accent: #DAFFD1;
    --peelo-cream: #FCFAF7;
    --bg-color: #FCFAF7;
    --text-color: #143028;
    --glass-bg: rgba(252, 250, 247, 0.7);
    --border-color: rgba(20, 48, 40, 0.05);
    --card-bg: #FFFFFF;
    --hover-bg: rgba(20, 48, 40, 0.04);
}

.griot-studio-container.dark-mode {
    --bg-color: #0A1A16;
    --text-color: #FFFFFF;
    --glass-bg: rgba(10, 26, 22, 0.7);
    --border-color: rgba(255, 255, 255, 0.05);
    --card-bg: rgba(255, 255, 255, 0.03);
    --hover-bg: rgba(255, 255, 255, 0.08);
}

/* --- LAYOUT --- */
.griot-studio-container {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    /* font-family property removed to inherit from App.vue */
    background-color: var(--bg-color);
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    z-index: 100;
    transition: background-color 0.5s ease, color 0.5s ease;
    overflow: hidden; /* Critical for inner scrolling */
}

/* --- TOP BAR --- */
.top-bar {
    height: 64px; /* Reduced from 80px */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-bottom: 1px solid var(--border-color);
    backdrop-filter: blur(20px);
    z-index: 200;
}

/* SELECTION BAR */
.selection-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 16px;
    margin-bottom: 12px;
}
.selection-bar .flex { display: flex; align-items: center; gap: 8px; }

.btn-select-all {
    /* Tailwind: p-3 rounded-xl transition-all shadow-md flex items-center gap-2 bg-white/5 border border-white/10 */
    padding: 12px;
    border-radius: 12px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: var(--text-primary);
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
}
.btn-select-all:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-1px);
}
.selection-count-badge {
    background: var(--peelo-green);
    color: white;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.griot-studio-container:not(.dark-mode) .btn-select-all {
   background: rgba(0,0,0, 0.05);
   border: 1px solid rgba(0,0,0, 0.1);
   color: #1e293b;
}
.griot-studio-container:not(.dark-mode) .btn-select-all:hover {
   background: rgba(0,0,0, 0.08);
}
.top-bar-left, .top-bar-right {
    display: flex;
    align-items: center;
    gap: 24px;
}

.btn-subtle {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
    opacity: 0.4;
    transition: opacity 0.2s;
    background: none;
    border: none;
    color: currentColor;
    cursor: pointer;
    padding: 0;
}
.btn-subtle:hover { opacity: 1; }

.bot-identity-group {
    display: flex;
    align-items: center;
    gap: 16px;
    padding-left: 24px;
    border-left: 1px solid var(--border-color);
}

.logo-box {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background: rgba(218, 255, 209, 0.1);
    color: #DAFFD1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dark-mode .logo-box { color: #DAFFD1; }
.griot-studio-container:not(.dark-mode) .logo-box { background: rgba(20, 48, 40, 0.1); color: #143028; }

.bot-name {
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.01em;
    margin: 0;
}
.version { opacity: 0.2; font-style: normal; font-weight: 400; }

.status-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
}
.status-dot { width: 8px; height: 8px; border-radius: 50%; background: #10B981; }
.status-dot.unsaved { background: #F59E0B; animation: pulse 1s infinite; }
.status-text { font-size: 9px; font-weight: 600; letter-spacing: 0.1em; opacity: 0.3; }

/* --- CONTROLS --- */
.btn-icon-square {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--hover-bg);
    border: none;
    color: currentColor;
    cursor: pointer;
    transition: all 0.2s;
}
.btn-icon-square:hover { background: var(--border-color); }



.pulse-overlay {
    position: absolute;
    inset: 0;
    background: white;
    opacity: 0.2;
    animation: pulse 1.5s infinite;
}

/* --- MAIN BODY --- */
.studio-body {
    flex: 1;
    display: flex;
    overflow: hidden; /* Ensure children handle scrolling */
    position: relative;
    min-height: 0; /* Flexbox scrolling fix */
    /* Removed height: 100% to let flexbox calculate correct height */
}

/* 1. NAV RAIL */
.nav-rail {
    width: 64px; /* Final aggressive reduction */
    border-right: 1px solid var(--border-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 0;
    gap: 12px; /* Tighter gap */
    background: var(--bg-color);
    z-index: 500; /* High z-index to ensure tooltip visibility */
    overflow: visible; /* Ensure tooltips are not clipped */
    position: relative; /* Create stacking context */
}
.nav-group { display: flex; flex-direction: column; gap: 12px; align-items: center; }
.nav-divider { width: 32px; height: 1px; background: var(--border-color); }

.nav-item {
    position: relative;
    width: 40px; /* Reduced to 40px */
    height: 40px; /* Reduced to 40px */
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: currentColor;
    opacity: 0.4;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.nav-item svg { width: 20px; height: 20px; } /* Keep icons readable */
.nav-item:hover { background: var(--hover-bg); opacity: 1; }
.nav-item.active {
    background: var(--peelo-green); 
    color: white; 
    opacity: 1; 
    transform: scale(1.05);
    box-shadow: 0 5px 15px -5px rgba(0,0,0,0.2);
}
.dark-mode .nav-item.active {
    background: var(--peelo-accent); 
    color: var(--peelo-green);
    box-shadow: 0 0 15px rgba(218, 255, 209, 0.2);
}

.tooltip {
    position: absolute;
    left: calc(100% + 12px);
    top: 50%;
    transform: translateY(-50%);
    background: #10B981;
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    z-index: 9999;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
    transition: opacity 0.2s ease;
}
/* Tooltip arrow */
.tooltip::before {
    content: '';
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
    border-right-color: #10B981;
}
.dark-mode .tooltip { 
    background: #ffffff; 
    color: #1a1a2e; 
    box-shadow: 0 4px 12px rgba(0,0,0,0.25); 
}
.dark-mode .tooltip::before { 
    border-right-color: #ffffff; 
}
.nav-item:hover .tooltip { 
    opacity: 1; 
}

/* 2. RESOURCE EXPLORER */
.resource-explorer {
    width: 360px;
    border-right: 1px solid var(--border-color);
    background: rgba(255,255,255,0.02);
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto !important; /* Force scroll */
    min-height: 0;
}
.griot-studio-container:not(.dark-mode) .resource-explorer { background: #f8fafc; }

.explorer-header {
    padding: 32px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.header-titles h2 { font-size: 20px; font-weight: 700; font-style: italic; letter-spacing: -0.02em; margin: 0; }
.header-titles p { font-size: 11px; font-weight: 600; letter-spacing: 0.1em; opacity: 0.5; margin-top: 4px; }

.btn-fab {
    width: 40px; height: 40px;
    border-radius: 12px;
    background: var(--peelo-green);
    color: white;
    border: none;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: transform 0.2s;
}
.dark-mode .btn-fab { background: var(--peelo-accent); color: var(--peelo-green); }
.btn-fab:hover { transform: scale(1.1); }

.search-row { padding: 0 32px 24px; }
.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}
.search-input-wrapper input {
    width: 100%;
    height: 56px;
    padding: 0 24px 0 56px;
    border-radius: 16px;
    border: 2px solid var(--border-color);
    background: transparent;
    color: currentColor;
    font-size: 12px;
    font-weight: 700;
    outline: none;
    transition: all 0.2s;
}
.search-input-wrapper input:focus { border-color: rgba(16, 185, 129, 0.3); }
.search-icon { position: absolute; left: 24px; opacity: 0.3; }

.explorer-content { flex: 1; overflow-y: auto; padding: 0 24px 32px; }
.explorer-content::-webkit-scrollbar { width: 6px; }
.explorer-content::-webkit-scrollbar-track { background: transparent; }
.explorer-content::-webkit-scrollbar-thumb { background: transparent; border-radius: 10px; transition: background 0.3s; }
.explorer-content:hover::-webkit-scrollbar-thumb { background: rgba(128,128,128, 0.4); }
.explorer-content::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128, 0.6); }
.cards-stack { display: flex; flex-direction: column; gap: 16px; }

/* Bento Cards */
.bento-card {
    background: var(--card-bg);
    border: 2px solid transparent;
    border-radius: 16px; /* Reduced further */
    padding: 10px; /* Aggressive reduction from 16px */
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    overflow: hidden;
}
.bento-card:hover { transform: translateY(-4px); box-shadow: 0 20px 40px -10px rgba(0,0,0,0.2); }
.griot-studio-container:not(.dark-mode) .bento-card { border-color: rgba(0,0,0,0.05); }

.bento-card.selected {
    border-color: #10B981;
    background: rgba(16, 185, 129, 0.1);
}
.griot-studio-container:not(.dark-mode) .bento-card.selected { background: #f0fdf4; border-color: #143028; }

.card-top { display: flex; justify-content: space-between; margin-bottom: 16px; }
.type-pill { 
    font-size: 9px; font-weight: 600; letter-spacing: 0.1em; 
    background: var(--border-color); padding: 4px 12px; border-radius: 20px; color: currentColor; opacity: 0.6;
}
.card-title { font-size: 15px; font-weight: 600; margin: 0 0 8px; letter-spacing: -0.01em; }
.card-desc { font-size: 11px; opacity: 0.5; font-style: italic; line-height: 1.6; margin: 0; }

.selection-circle {
    width: 24px; height: 24px;
    border-radius: 50%;
    border: 2px solid var(--border-color);
    display: flex; align-items: center; justify-content: center;
}
.selected .selection-circle { background: #10B981; border-color: #10B981; color: #0A1A16; }

/* Product Row Layout */
.bento-card.row-layout {
    display: flex; align-items: center; gap: 12px; padding: 10px; /* Tighter gap and padding */
}
.card-icon-box {
    width: 40px; height: 40px; border-radius: 10px; /* Smaller icon box */
    background: var(--hover-bg); display: flex; align-items: center; justify-content: center;
    overflow: hidden; /* Ensure image doesn't overflow */
}
.product-img-cover {
    width: 100%; height: 100%; object-fit: cover;
}
.card-info { flex: 1; min-width: 0; }

/* Upload Area */
.upload-area {
    border: 3px dashed var(--border-color);
    border-radius: 40px;
    padding: 40px;
    display: flex; flex-direction: column; align-items: center; text-align: center; gap: 24px;
    cursor: pointer;
    transition: all 0.2s;
}
.upload-area:hover { border-color: var(--peelo-green); background: rgba(20, 48, 40, 0.05); }
.dark-mode .upload-area:hover { border-color: var(--peelo-accent); background: rgba(218, 255, 209, 0.05); }

.list-header {
    display: flex; justify-content: space-between;
    font-size: 10px; font-weight: 900; letter-spacing: 0.2em; opacity: 0.3;
    margin: 24px 0 16px;
}

/* 3. MAIN CANVAS */
.main-canvas {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto !important; /* Force scroll */
    height: 100%;
    min-height: 0;
}
.canvas-content {
    flex: 1;
    padding: 48px;
    display: flex; flex-direction: column;
}

/* Code Editor */
.canvas-header {
    display: flex; justify-content: space-between; margin-bottom: 40px;
}
.actions-group { display: flex; gap: 16px; }

.btn-action {
    display: flex; align-items: center; gap: 8px;
    padding: 12px 24px;
    border-radius: 12px;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    color: currentColor;
    font-size: 12px; font-weight: 600; letter-spacing: 0.05em;
    cursor: pointer;
    transition: all 0.2s;
}
.btn-action:hover { transform: translateY(-2px); box-shadow: 0 10px 20px -5px rgba(0,0,0,0.1); }

.code-window {
    flex: 1;
    border-radius: 24px;
    background: rgba(10, 26, 22, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.5);
}

.window-bar {
    height: 48px;
    background: rgba(0,0,0,0.3);
    display: flex; align-items: center; padding: 0 24px; gap: 24px;
}
.traffic-lights { display: flex; gap: 8px; }
.light { width: 12px; height: 12px; border-radius: 50%; }
.red { background: #FF5F56; } .yellow { background: #FFBD2E; } .green { background: #27C93F; }
.window-title { font-family: monospace; font-size: 12px; color: #64748B; letter-spacing: 0.1em; }

.code-editor {
    flex: 1;
    background: transparent;
    border: none;
    color: #E2E8F0;
    font-family: 'Menlo', monospace;
    font-size: 13px;
    line-height: 1.6;
    padding: 32px;
    resize: none;
    outline: none;
}

/* Dashboard Mode */
.dashboard-intro { margin-bottom: 48px; }
.dashboard-intro h3 { font-size: 32px; font-weight: 700; font-style: italic; letter-spacing: -0.02em; margin: 0; line-height: 1.2; }
.dashboard-intro p { font-size: 12px; font-weight: 600; letter-spacing: 0.1em; margin-top: 8px; opacity: 0.5; }

.grid-2-col { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; }
.status-card {
    background: var(--card-bg);
    border: 2px solid var(--border-color);
    border-radius: 32px;
    padding: 32px;
}
.card-header { display: flex; align-items: center; gap: 16px; margin-bottom: 24px; }
.card-header h4 { font-size: 11px; font-weight: 600; letter-spacing: 0.1em; margin: 0; opacity: 0.7; }
/* CSS fix for mini-list */
.mini-list { 
    margin-top: 12px; 
    display: grid; 
    gap: 8px; 
    max-height: 400px; 
    overflow-y: auto; 
    padding-right: 4px;
}
/* Custom Scrollbar for mini-list */
.mini-list::-webkit-scrollbar { width: 4px; }
.mini-list::-webkit-scrollbar-thumb { background: rgba(128,128,128, 0.2); border-radius: 10px; }

.mini-item { 
    display: flex; align-items: center; gap: 12px; 
    padding: 10px 14px; /* Slightly increased padding */
    background: rgba(255,255,255,0.03); 
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 12px; 
    font-size: 13px; /* Increased from 11px */
    font-weight: 500; 
    transition: all 0.2s;
}
.mini-item:hover {
    background: rgba(255,255,255,0.06);
    transform: translateX(2px);
    border-color: rgba(255,255,255,0.1);
}
.griot-studio-container:not(.dark-mode) .mini-item {
    background: #f8fafc;
    border-color: #e2e8f0;
}
.griot-studio-container:not(.dark-mode) .mini-item:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.mini-icon-box {
    width: 36px; height: 36px; /* Increased from 28px */
    border-radius: 10px;
    overflow: hidden;
    display: flex; align-items: center; justify-content: center;
    background: rgba(128,128,128,0.15);
    color: var(--peelo-green);
    flex-shrink: 0;
}
.mini-product-img {
    width: 100%; height: 100%; object-fit: cover;
}

/* Larger Mini-Item Variant */
.mini-item-lg {
    padding: 14px 16px;
}
.mini-item-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}
.mini-item-name {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.mini-item-id {
    font-size: 10px;
    font-weight: 500;
    opacity: 0.4;
    font-family: 'Menlo', monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Scrollbar */
/* refined scrollbar */
.custom-scroll::-webkit-scrollbar { width: 4px; }
.custom-scroll::-webkit-scrollbar-track { background: transparent; }
.custom-scroll::-webkit-scrollbar-thumb { background: transparent; border-radius: 10px; transition: background 0.3s; }
.custom-scroll:hover::-webkit-scrollbar-thumb { background: rgba(128,128,128, 0.4); } 
.custom-scroll::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128, 0.6); }

/* specific for mini-list to match */
.mini-list::-webkit-scrollbar { width: 4px; }
.mini-list::-webkit-scrollbar-thumb { background: rgba(128,128,128, 0.2); border-radius: 10px; }
.mini-list:hover::-webkit-scrollbar-thumb { background: rgba(128,128,128, 0.5); }

/* Sync Status */
.sync-card-wrapper { margin-top: 32px; }
.sync-status-row {
    display: flex; align-items: center; gap: 24px;
    padding: 32px;
    border-radius: 32px;
    border: 3px dashed var(--border-color);
    background: rgba(20, 48, 40, 0.02);
}
.sync-icon-box {
    width: 48px; height: 48px; border-radius: 16px; /* w-12 h-12 rounded-2xl */
    background: rgba(16, 185, 129, 0.1); color: #10B981; /* bg-emerald-500/10 text-emerald-500 */
    display: flex; align-items: center; justify-content: center;
}
.sync-icon-box.active { background: rgba(45, 212, 191, 0.1); color: #2DD4BF; } /* Electric Green/Teal */
.sync-info { flex: 1; }
.sync-info h4 {
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    opacity: 0.9;
}
.sync-info p {
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 10px;
    opacity: 0.6;
    margin: 2px 0 0 0;
    font-weight: 500;
}

.btn-sync-action {
    height: 48px; padding: 0 24px; border-radius: 12px; /* Reduced specific button size */
    background: var(--peelo-accent); color: var(--peelo-green);
    font-size: 10px; font-weight: 800; letter-spacing: 0.1em;
    border: none; cursor: pointer; transition: all 0.2s;
}
.btn-sync-action:hover { transform: scale(1.02); box-shadow: 0 10px 20px -10px rgba(16, 185, 129, 0.3); }

/* Animations */
@keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
@keyframes spin { from {transform: rotate(0deg);} to {transform: rotate(360deg);} }

/* --- RESPONSIVE / MOBILE STYLES --- */
.desktop-only-flex { display: flex; }
.mobile-only-flex { display: none; }

@media (max-width: 1024px) {
    .resource-explorer { width: 320px; }
    .grid-2-col { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
    .desktop-only-flex { display: none !important; }
    .mobile-only-flex { display: flex !important; }
    
    .griot-studio-container {
        padding-bottom: 70px; /* Space for bottom nav */
    }
    
    .top-bar {
        padding: 0 16px;
        height: 64px;
    }
    .bot-name { font-size: 14px; }
    
    .btn-sync { 
        width: 48px; 
        height: 48px; 
        padding: 0 !important; 
        justify-content: center; 
    }
    .btn-sync span:not(.pulse-overlay) { display: none; }
    
    .studio-body {
        flex-direction: column;
    }
    
    /* Hide desktop sidebar on mobile */
    .side-nav {
        display: none !important;
    }
    
    /* Show mobile bottom nav with horizontal scroll capability */
    .mobile-bottom-nav {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 70px;
        background: var(--bg-color);
        border-top: 1px solid var(--border-color);
        display: flex !important;
        align-items: center;
        justify-content: space-around;
        padding: 0 8px;
        z-index: 1000;
        gap: 4px;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
    .mobile-bottom-nav::-webkit-scrollbar { display: none; }
    
    .mobile-nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 56px;
        min-width: 56px;
        height: 52px;
        gap: 4px;
        background: transparent;
        border: none;
        color: var(--text-color);
        opacity: 0.5;
        cursor: pointer;
        border-radius: 12px;
        transition: all 0.2s;
    }
    .mobile-nav-item svg { width: 22px; height: 22px; }
    .mobile-nav-item span { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.02em; }
    .mobile-nav-item:hover { opacity: 1; background: var(--hover-bg); }
    .mobile-nav-item.active { 
        opacity: 1; 
        color: var(--peelo-green); 
        background: rgba(16, 185, 129, 0.1);
    }
    
    /* Responsive Content Switching */
    .resource-explorer, .main-canvas {
        width: 100%;
        border-right: none;
    }
    
    /* Force scroll on mobile too */
    .resource-explorer, .main-canvas {
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
        height: auto; /* Let content dictate height on mobile if needed, or keeping 100% if fixed container */
        flex: 1;
    }
    
    /* Ensure one is hidden and other is shown */
    .resource-explorer { display: none; }
    .resource-explorer:not(.mobile-hidden) { display: flex; flex: 1; }
    
    .main-canvas { display: none; }
    .main-canvas:not(.mobile-hidden) { display: flex; flex: 1; }
    
    /* Hide scrollbars on mobile for cleaner look */
    .custom-scroll::-webkit-scrollbar { display: none; }
}

/* TAILWIND UTILITIES FOR FILE MANAGER */
.hidden { display: none; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.gap-6 { gap: 1.5rem; }
.gap-5 { gap: 1.25rem; }
.gap-2 { gap: 0.5rem; }
.p-6 { padding: 1.5rem; }
.p-10 { padding: 2.5rem; }
.p-5 { padding: 1.25rem; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.pt-4 { padding-top: 1rem; }
.p-2\.5 { padding: 0.625rem; }
.space-y-4 > :not([hidden]) ~ :not([hidden]) { margin-top: 1rem; }
.space-y-6 > :not([hidden]) ~ :not([hidden]) { margin-top: 1.5rem; }
.w-20 { width: 5rem; }
.h-20 { height: 5rem; }
.w-12 { width: 3rem; }
.h-12 { height: 3rem; }
.w-40 { width: 10rem; }
.rounded-\[2\.5rem\] { border-radius: 2.5rem; }
.rounded-\[2rem\] { border-radius: 2rem; }
.rounded-3xl { border-radius: 1.5rem; }
.rounded-2xl { border-radius: 1rem; }
.rounded-xl { border-radius: 0.75rem; }
.border-4 { border-width: 4px; }
.border-2 { border-width: 2px; }
.border-dashed { border-style: dashed; }
.border-white\/5 { border-color: rgba(255, 255, 255, 0.05); }
.bg-white\/5 { background-color: rgba(255, 255, 255, 0.05); }
.border-transparent { border-color: transparent; }
.text-center { text-align: center; }
.text-xs { font-size: 0.75rem; line-height: 1rem; }
.text-\[10px\] { font-size: 10px; }
.text-\[9px\] { font-size: 9px; }
.font-black { font-weight: 900; }
.uppercase { text-transform: uppercase; }
.tracking-\[0\.2em\] { letter-spacing: 0.2em; }
.tracking-\[0\.3em\] { letter-spacing: 0.3em; }
.tracking-tight { letter-spacing: -0.025em; }
.italic { font-style: italic; }
.opacity-30 { opacity: 0.3; }
.opacity-40 { opacity: 0.4; }
.opacity-50 { opacity: 0.5; }
.opacity-0 { opacity: 0; }
.group:hover .group-hover\:opacity-100 { opacity: 1; }
.group:hover .group-hover\:scale-110 { transform: scale(1.1); }
.transition-all { transition-property: all; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 300ms; }
.transition-transform { transition-property: transform; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 300ms; }
.duration-500 { transition-duration: 500ms; }
.cursor-pointer { cursor: pointer; }
.relative { position: relative; }
.overflow-hidden { overflow: hidden; }
.truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.flex-1 { flex: 1 1 0%; }
.min-w-0 { min-width: 0px; }
.hover\:border-emerald-500\/30:hover { border-color: rgba(16, 185, 129, 0.3); }
.hover\:bg-emerald-500\/5:hover { background-color: rgba(16, 185, 129, 0.05); }
.bg-red-500\/10 { background-color: rgba(239, 68, 68, 0.1); }
.text-red-500 { color: rgb(239, 68, 68); }
.hover\:bg-red-500\/10:hover { background-color: rgba(239, 68, 68, 0.1); }
.bg-blue-500\/10 { background-color: rgba(59, 130, 246, 0.1); }
.text-blue-500 { color: rgb(59, 130, 246); }
.bg-gray-500\/10 { background-color: rgba(107, 114, 128, 0.1); }
.text-gray-500 { color: rgb(107, 114, 128); }
.font-sans { font-family: 'Roboto', sans-serif !important; } /* Force Roboto as requested */

/* FILE MANAGEMENT STYLES */
.file-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
    background: var(--card-bg);
    border: 2px solid transparent;
    transition: all 0.2s;
    position: relative;
    cursor: default;
}
.griot-studio-container:not(.dark-mode) .file-card {
    border-color: rgba(0,0,0,0.05);
}
.file-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px -5px rgba(0,0,0,0.1);
    background: var(--hover-bg);
}

.file-icon {
    width: 40px; height: 40px;
    border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,0.05);
    color: white;
}
.file-icon.pdf { color: #F87171; background: rgba(248, 113, 113, 0.1); }
.file-icon.json { color: #FBBF24; background: rgba(251, 191, 36, 0.1); }
.file-icon.txt { color: #94A3B8; background: rgba(148, 163, 184, 0.1); }

.file-info { flex: 1; min-width: 0; }
.file-name { font-size: 13px; font-weight: 600; margin-bottom: 4px; pointer-events: none; }
.file-meta { font-size: 11px; opacity: 0.5; font-weight: 500; }

.btn-delete-file {
    width: 32px; height: 32px;
    border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    background: transparent;
    color: #ef4444;
    border: none;
    cursor: pointer;
    opacity: 0;
    transition: all 0.2s;
}
.file-card:hover .btn-delete-file { opacity: 1; }
.btn-delete-file:hover { background: rgba(239, 68, 68, 0.1); }

.upload-icon-circle {
    width: 64px; height: 64px;
    border-radius: 50%;
    background: rgba(16, 185, 129, 0.1);
    color: #10B981;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 16px;
}
.upload-title { font-size: 12px; font-weight: 800; letter-spacing: 0.1em; color: var(--peelo-green); }
.upload-desc { font-size: 11px; font-weight: 500; opacity: 0.5; margin-top: 4px; }
.dark-mode .upload-title { color: white; }

/* TOAST NOTIFICATION */
.toast-notification {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: #10B981;
    color: white;
    padding: 12px 24px;
    border-radius: 12px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: slideIn 0.3s ease-out;
}
.toast-notification.error {
    background: #EF4444;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}
@keyframes slideIn {
    from { transform: translateY(100%); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}

/* MODAL STYLES */
.modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(8px);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.modal-card {
    background: #1A1A1A;
    border: 1px solid rgba(255, 255, 255, 0.1);
    width: 100%;
    max-width: 400px;
    border-radius: 24px;
    padding: 32px;
    text-align: center;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modal-icon-wrapper {
    width: 64px; height: 64px;
    border-radius: 20px;
    background: rgba(239, 68, 68, 0.1);
    color: #EF4444;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 20px;
}

.modal-card h3 {
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 12px;
    color: white;
}

.modal-card p {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 24px;
    word-break: break-word; /* Ensure long filenames wrap */
}

.modal-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.btn-cancel, .btn-confirm-delete {
    height: 48px;
    border-radius: 14px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-cancel {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
}
.btn-cancel:hover {
    background: rgba(255, 255, 255, 0.05);
}

.btn-confirm-delete {
    background: #EF4444;
    border: none;
    color: white;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}
.btn-confirm-delete:hover {
    background: #DC2626;
    transform: translateY(-1px);
}
.btn-confirm-delete:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

@keyframes modalPop {
    from { opacity: 0; transform: scale(0.95) translateY(10px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* ===== CONSTITUTION EDITOR ===== */
.btn-save-constitution { background: #10B981; color: #fff; border-color: #10B981; }
.btn-save-constitution:hover { background: #0ea371; }
.btn-save-constitution:disabled { opacity: 0.6; cursor: not-allowed; }

.constitution-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    margin-top: 8px;
}
.const-field {
    display: flex;
    flex-direction: column;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 14px;
    padding: 16px;
    transition: border-color 0.2s ease;
}
.const-field:focus-within { border-color: rgba(16,185,129,0.4); }
.const-field-full { grid-column: 1 / -1; }
.const-field label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #E5E7EB;
    margin-bottom: 4px;
}
.const-emoji { font-size: 1rem; }
.const-hint {
    font-size: 0.76rem;
    color: #9CA3AF;
    margin: 0 0 10px 0;
    line-height: 1.4;
}
.const-textarea {
    width: 100%;
    resize: vertical;
    background: rgba(0,0,0,0.25);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 10px 12px;
    color: #F3F4F6;
    font-size: 0.85rem;
    line-height: 1.5;
    font-family: inherit;
    outline: none;
    transition: border-color 0.2s ease;
}
.const-textarea:focus { border-color: rgba(16,185,129,0.5); }
.const-textarea::placeholder { color: #6B7280; }
.const-footer-hint {
    margin-top: 18px;
    padding: 12px 16px;
    background: rgba(16,185,129,0.08);
    border: 1px solid rgba(16,185,129,0.2);
    border-radius: 10px;
    color: #A7F3D0;
    font-size: 0.8rem;
    line-height: 1.45;
}

/* MEDIA QUERIES EXTENSION */
@media (max-width: 768px) {
    .griot-studio-container {
        height: 100vh;
        overflow: hidden;
    }
    .studio-body {
        height: calc(100vh - 64px - 70px);
        overflow-y: auto;
    }
    .resource-explorer, .main-canvas {
        overflow: visible;
        height: auto;
    }
    .constitution-grid { grid-template-columns: 1fr; }
}
</style>